import { render, staticRenderFns } from "./FormsWidget.vue?vue&type=template&id=e59ddef0"
import script from "./FormsWidget.vue?vue&type=script&lang=js"
export * from "./FormsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports